<template>
    <div class="bg-bat-quiz">
        <section class="py-md-3">
            <div class="container py-2 ">
                <div class="breadcrumbs-retos mx-2">
                    <a href="/home-bat">
                        <img src="/img/icons/homeBread.svg" alt=""/>
                    </a>
                    <a class="link cursor-pointer" href="#" @click="returnView()">Gana puntos </a>
                    <a class="link cursor-pointer" href="#" @click="returnView()">Aprendizaje /</a>
                    <span class="color-active-miga" v-if="learning !== null"><strong>Quiz {{ learning.title }}</strong></span>
                </div>
                <a class="mx-2" href="#" @click="returnView()"><img src="/img/icons/regresar.svg" alt="icon"></a>
            </div>
        </section>

        <div class="row text-bat">
            <div class="col-sm-11 col-md-9 col-lg-6 col-xl-8 mx-auto pb-5 datos">
                <div v-if="learning !== null" class="m-3">
                    <h4 class="text-indigo-dark text-title-bat" v-if="learning">{{ learning.title }}</h4>
                    <h6 class="text-bat">Responde las siguiente preguntas. Recuerda que para aprobar el quiz, necesitas responder correctamente <strong class="text-title-bat">{{
                                questions.length * Number(learning.percentage_to_win) / 100
                            }}  de </strong>
                        <strong class="text-title-bat">{{ questions.length }}</strong> preguntas
                        <strong>¡Buena suerte!</strong></h6>
                        <strong>Total preguntas {{ questions.length }}</strong>
                        <p>Apruebas con {{ learning.percentage_to_win }}% de aciertos</p>
                </div>
                <div style="display: flex; justify-content: center;">
            <div style="
                width: 624px;
                height: 2px;
                flex-shrink: 0;
                border-radius: 4px;
                background: rgba(31, 18, 30, 0.10);
            "></div>
            </div>

                <div v-if="questions.length > 0">
                    <div v-for="(question, index) in questions" class="pb-4 m-3 p-3 bg-questions-quiz rounded-4">
                        <h6 class="text-indigo-dark me-2"><span class="list-point-list">{{ index + 1 }}</span>
                            {{ question.question }}</h6>
                        <div v-if="question.learning_question_type_id === 1">
                            <el-radio-group v-model="question.answer" class="ms-4">
                                <div v-for="option in question.options" class="py-2">
                                    <el-radio :label="option.id" class="radio-quiz" size="large">{{ option.option }}</el-radio>
                                </div>
                            </el-radio-group>
                        </div>
                        <div v-else-if="question.learning_question_type_id === 2" class="ms-4 py-2">
                            <el-input
                                type="textarea"
                                placeholder="Ingresa tu respuesta"
                                v-model="question.answer"
                                maxlength="150"
                                show-word-limit
                                :autosize="{ minRows: 5, maxRows: 7}"
                                resize="none"
                            >
                            </el-input>
                        </div>
                        <div v-else-if="question.learning_question_type_id === 3">
                            <el-checkbox-group v-model="question.answer" class="ms-4">
                                <div v-for="option in question.options" class="py-2">
                                    <el-checkbox :label="option.option"></el-checkbox>
                                </div>
                            </el-checkbox-group>
                        </div>

                    </div>
                </div>
                <div class="">
                    <!-- <div v-if="errors.length" class="border border-2 border-danger bg-danger text-white p-4 mb-4">
                        <ul>
                            <li v-for="error in errors">{{ error }}</li>
                        </ul>
                    </div> -->
                    <div class="pb-4 m-3 p-3">
                        <p v-if="first_unanswered_index"
                            class="d-flex align-items-center p-3 mb-3"
                            style="color: #F00; background-color: #FFDED9; border-left: 4px solid #F00; font-weight: 600; font-size: 14px;">
                            <img
                                class="me-3"
                                src="/img-version2/icons/danger.svg"
                                alt="icon"
                                style="width: 20px; height: 20px;"
                            />
                            Debes responder la pregunta {{ first_unanswered_index }} antes de finalizar el quiz.
                        </p>
                    </div>



                    <!-- Si está cargando -->
                    <!-- <div class="d-flex justify-content-between gap-3 flex-column flex-md-row">
                        <div class="button button-blue px-5 w-100">
                            <i class="fa-solid fa-spinner fa-spin-pulse"></i> {{ $t('earnPoints.finish') }}
                        </div>
                    </div> -->

                    <!-- Si NO está cargando -->
                    <div class="d-flex justify-content-between gap-3 flex-column flex-md-row m-3">
                    <!-- Botón Enviar respuestas (primero) -->
                    <!-- <div @click="finishQuiz" class="button button-blue px-5 w-100">
                        Enviar mis respuestas
                    </div> -->

                    <button
                        @click="finishQuiz"
                        class="button button-blue px-5 w-100"
                        :disabled="isSubmitting"
                    >
                        {{ isSubmitting ? 'Enviando...' : 'Enviar mis respuestas' }}
                    </button>

                    <!-- Botón Cancelar (a la derecha) -->
                        <div class="mt-2 px-5 w-100 text-more cursor-pointer text-decoration-underline text-center" @click="cancel" >
                           Cancelar
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog
            :visible.sync="modal_finish"
            :width="$mq === 'sm' ? '90%' : $mq==='xl' ? '30%' : '50%'"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false">
            <div class="text-center justify-content-center text-bat">
                <p v-if="success_message" v-html="success_message"></p>
                <p v-html="learning.quiz_end_message"></p>
                <a class="btn btnBlue mb-2 mb-xl-0" v-if="!getVisibiltyFeedback()"
                   :href="`/learning/${learning.id}/quiz/feedback`">Ver retroalimentación</a>
                <a class="btn btn-secondary" href="#" @click="returnView()">Regresar a gana puntos</a>
            </div>
        </el-dialog>

        <el-dialog
            :visible.sync="modal_cancel"
            width="320px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="true"
            class="cancel-popup"
        >
            <div class="text-center p-3 d-flex flex-column align-items-center justify-content-center">

                <div class="circle-icon mb-3">
                <img src="/img-version2/modal/close-circle.svg" alt="Cancelar" width="60" height="60">
                </div>

                <h5 class="fw-bold mb-2">¿Estás seguro de que quieres cancelar esta lección?</h5>
                <p class="text-secondary mb-4">Si la cancelas ahora, perderás tu progreso.</p>

                <a type="primary" class="button button-blue px-5" @click="modal_cancel = false">
                    Seguir con la lección
                </a>

                <a href="#" class="mt-4 px-5 w-100 text-more cursor-pointer text-decoration-underline text-center" @click.prevent="cancelLesson">
                    Sí, cancelar
                </a>
            </div>
        </el-dialog>

        <el-dialog
            :visible.sync="modal_revision"
            :width="$mq === 'sm' ? '95%' : $mq === 'md' ? '35%' : '20%'"
            :close-on-press-escape="true"
            :close-on-click-modal="true"
            :show-close="true"
            @close="returnView"
            @closed="returnView"
            >
            <div class="d-flex flex-column justify-content-center align-items-center text-center text-break">
                <i class="fa-solid fa-triangle-exclamation fs-1 mb-3" style="color: #fec52f;"></i>
                <h4 class="text-indigo-darkness">Tu quiz está en proceso de revisión.</h4>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        learning: {
            default: null,
        },
    },
    data() {
        return {
            loading: 0,
            questions: [],
            modal_finish: false,
            errors: [],
            results_coming_soon: false,
            success_message: '',
            first_unanswered_index: null,
            modal_cancel: false,
            modal_revision: false,
            isSubmitting: false,
        }
    },
    mounted() {
        this.loadQuestions()
    },
    methods: {
        loadQuestions() {
            this.loading++
            axios.get(`/learning/${this.learning.id}/load-questions`).then(
                ({data}) => {
                    this.questions = data.questions
                    this.loading--
                })
        },
        finishQuiz() {
            if (this.isSubmitting) return;           // evita múltiples clics
            this.isSubmitting = true;

            console.log('antes de validar respuestas');
            this.validateAnswers()
            console.log('después de validar respuestas');
            if (this.errors.length === 0) {
                this.loading++
                axios.post(`/learning/${this.learning.id}/finish-quiz`, {questions: this.questions}).then(
                    ({data}) => {
                        console.log('finalizar')
                        console.log(data.is_linked)
                        this.success_message = data.message
                        if (data.coming_soon) {
                            this.results_coming_soon = true
                        }
                    }).catch((error) => {
                    console.log(error)
                }).catch((error) => {
                    console.log(error);
                    this.isSubmitting = false;           // reactivar si falla la petición
                }).finally(() => {
                    this.loading--

                    const hasType2 = this.questions.some(q => q.learning_question_type_id === 2)

                    if (hasType2) {
                        // Aquí haces lo que necesites si existe al menos una pregunta con type_id === 2
                        this.modal_revision = true;
                        console.log('Hay al menos una pregunta tipo 2')
                        // Por ejemplo, podrías mostrar un modal, redirigir a otro lugar, etc.
                    } else {
                        // Si no hay ninguna pregunta tipo 2, redirige normalmente
                        window.location.href = `/learning/${this.learning.id}/quiz/feedback`
                    }
                })
            }
        },
        validateAnswers() {
            this.errors = []
            this.first_unanswered_index = null
            let i = 1
            for (var question of this.questions) {
                if (question.answer === null) {
                     if (this.first_unanswered_index === null) {
                        this.first_unanswered_index = i
                    }
                    this.errors.push(`Debes contestar la pregunta ${i} antes de finalizar el quiz.`)
                } else {
                    if (question.learning_question_type_id === 2 && question.answer === '') {
                         if (this.first_unanswered_index === null) {
                            this.first_unanswered_index = i
                        }
                        this.errors.push(`Debes contestar la pregunta ${i} antes de finalizar el quiz.`)
                    } else if (question.learning_question_type_id === 3 && question.answer.length === 0) {
                         if (this.first_unanswered_index === null) {
                            this.first_unanswered_index = i
                        }
                        this.errors.push(`Debes seleccionar al menos una opción en la pregunta ${i} antes de finalizar el quiz.`)
                    }
                }
                i++
            }
        },
        getVisibiltyFeedback() {
            for (const question of this.questions) {
                if (question.learning_question_type_id === 2) {
                    return true;
                }
            }
            return false;
        },
        returnView() {
            // window.location.reload();
            window.location.href = '/retos?page=1&option=learning';
        },
        cancel() {
            this.modal_cancel = true;
        },
        cancelLesson() {
            window.location.href = '/retos';
        }
    }
}
</script>
